<template>
    <section class="marquee deposit-tab">
        <div class="container">
            <div class="deposit-outer">
                <div class="fast-bank-deposit b-contant d_w_heading">
                    <div class="back-btn p-al">
                        <a @click="$router.go(-1)" class="back-btn-lef">
                            <img src="@/assets/images/left-arrow-bg.png" alt="" />{{ $t('back', 'Back') }}
                        </a>
                        <span class="bank-deps">{{ $t('fast-bank-deposit', 'Deposit') }}</span>
                    </div>
                </div>
                <div class="deposit-outer-body deposit_w_t" v-if="(parentPaymentsList && Object.keys(parentPaymentsList).length) || ($siteSettings?.data?.social_link && ($siteSettings?.data?.social_link?.whatsappno1 || $siteSettings?.data?.social_link?.whatsappno2)) ">
                    <div class="inner-body">
                        <div class="wallet_thm_title">
                            <h2>Choose a payment method</h2>
                        </div>
                        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                            <li v-for="(paymentData, payment) in parentPaymentsList" :key="payment" class="nav-item border_blink" role="presentation">
                                <button class="nav-link" :class="{ active: activeTab === payment}, paymentBonus?.[paymentData?.[0]?.method_id] ? 'paymentBonus' : ''" @click="choosePaymentMethod(paymentData, payment)" 
                                    data-bs-toggle="tab" type="button" role="tab">
                                    <div class="get-bonus-sec" v-if="paymentBonus?.[paymentData?.[0]?.method_id]">Get {{ paymentBonus?.[paymentData?.[0]?.method_id] }}% Bonus</div>
                                    <div class="bank-img">
                                        <img loading="lazy" :src="methodIcons[payment]"  />
                                    </div> {{ payment }}
                                </button>
                            </li>
                        </ul>
                        <div class="wallet_thm_title" v-if="accountDetails?.method == 'bank' && !isSocialPaymentMethodSelected">
                            <h2>You can add through a bank transfer</h2>
                        </div>
                        <div class="tab-content" id="pills-tabContent">
                            <div role="tabpanel" >
                                <form>
                                    <div class="payment-gateway-sec" v-if="isPaymentGateway">
                                        <span>Pay using our payemnt gateway</span>
                                        <a href="Javascript:void(0);" @click="goToPaymentGateway()" class="thm-but">{{ $t('pay-now', 'Pay Now') }}</a>
                                    </div>
                                    <div class="form-inner" v-if="isShowDepositeBody">
                                        <div class="acc-number" v-for="(account, index) in paymentDetailsList" @click="changeAccount(account,index)" :key="index" :class="{ 'selected-card' : isActive(index, account) }" >
                                            <div class="acc-number-pr">
                                                <div class="acc-number-body">
                                                    <div class="detail-c deposit_bank_list">
                                                        <ul>
                                                            <li v-if="account?.account_number || account?.phone_number">
                                                                <span>
                                                                    {{ account?.account_number ? $t('account-number', 'Account Number') : $t('phone-number', 'Phone Number') }}
                                                                </span>
                                                                <span class="double_dots_width">:</span>
                                                                <span>{{ account?.account_number ? account?.account_number : account?.phone_number }}</span>
                                                                <button type="button" @click="copyPaymentData(account?.account_number ? $t('account-number', 'Account Number') : $t('phone-number', 'Phone Number'), account.account_number ? account.account_number : account.phone_number)" class="blinl-messege copy_bank_btn12">
                                                                    <img src="@/assets/images/copy.png" alt="" />
                                                                </button>
                                                            </li>
                                                            <li>
                                                                <span>
                                                                   {{ account.account_number ? $t('ifsc-code', 'IFSC Code') : account?.upi_id ? $t('upi-id', 'UPI ID') : $t('wallet-id', 'Wallet ID') }}
                                                                </span>
                                                                <span class="double_dots_width">:</span>
                                                                <span>{{ account.account_number ? account.ifsc_code : (account?.upi_id || account?.crypto_wallet_id) }}</span>
                                                                <button type="button" class="blinl-messege copy_bank_btn12" @click="copyPaymentData(account.account_number ? $t('ifsc-code', 'IFSC Code') : account?.upi_id ? $t('upi-id', 'UPI ID') : $t('wallet-id', 'Wallet ID'), account.account_number ? account.ifsc_code : (account?.upi_id || account?.crypto_wallet_id))">
                                                                    <img src="@/assets/images/copy.png" alt="" />
                                                                </button>
                                                            </li>
                                                            <li>
                                                                <span>
                                                                    {{ $t('display-name', 'Display Name') }}
                                                                </span>
                                                                <span class="double_dots_width">:</span>
                                                                <span>{{ account.account_holder_name }}</span>
                                                                <button type="button" class="blinl-messege copy_bank_btn12" @click="copyPaymentData($t('display-name', 'Display Name'), account?.account_holder_name)" >
                                                                    <img src="@/assets/images/copy.png" alt="" />
                                                                </button>
                                                            </li>
                                                            <li v-if="account?.crypto_wallet_id">
                                                                <span>
                                                                    Deposit Amount
                                                                </span>
                                                                <span class="double_dots_width">:</span>
                                                                <span>
                                                                    {{ (depositAmount/account?.multiplier_value)?.toFixed(2) }} {{ account?.method_name}}
                                                                    <span>( at x{{ Number(account?.multiplier_value) }} )</span>
                                                                </span>
                                                                <button type="button" class="blinl-messege copy_bank_btn12" @click="copyPaymentData('Deposit Amount', (depositAmount/account?.multiplier_value))" >
                                                                    <img src="@/assets/images/copy.png" alt="" />
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="qr_scaner_sec" v-if="account.qr_code" key="">
                                                <div class="click-qr-preview-img">
                                                    <ul>
                                                        <li>
                                                            <button class="click-qr-icons" @click.prevent="currentImgLink = (account.qr_code), $helper.openModal('#qrPreviewModal')">
                                                                <img loading="lazy" src="@/assets/images/qr-full-screen.svg" alt="qr-full-screen">
                                                            </button>
                                                        </li>
                                                        <li>
                                                            <button class="click-qr-icons"  @click.prevent="currentImgLink = (account.qr_code),$helper.openModal('#qrShareModal')">
                                                                <img loading="lazy" src="@/assets/images/qr-share.svg" alt="qr-share">
                                                            </button>
                                                        </li>
                                                        <li>
                                                            <button class="click-qr-icons" @click.prevent="downloadQrImg(account.qr_code, account?.account_holder_name)">
                                                                <img loading="lazy" src="@/assets/images/qr-downloads.svg" alt="qr-downloads">
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div class="qrCode-pic">
                                                    <figure>
                                                        <img loading="lazy" :src="account.qr_code" alt="QR-Code">
                                                    </figure>
                                                </div>
                                            </div>
                                            <!-- <div class="select-box" v-if="bankIndex !== activeIndex"> {{ $t('select-option', 'Select Option') }} - {{ bankIndex + 1 }} </div> -->
                                        </div>
                                        <!-- <h2 class="transactionhead">{{ $t('enter-transaction-details', 'ENTER Transaction details') }}</h2> -->
                                        <div class="uplode-img" >
                                            <span class="uplode-pay">{{ $t('upload-payment-reciept', 'upload payment reciept') }} ({{ $t('maximum-size-of-image-5mb', 'Maximum Size Of Image 5MB') }})
                                                <span class="uplode-red">*</span>
                                            </span>
                                            <div class="deposit-bg-border" v-if="!previewImage">
                                                <input type="file" ref="fileRef" @click="onFilePickerOpen" @change="fileUpdateFunc($event)" accept="image/png, image/jpeg, image/jpg, image/webp" class="uplode-img-input"   />
                                                <div class="deposit-bg-img">
                                                    <div class="downlodw-area">
                                                        <div class="downlodw-title_main">
                                                            <span>Choose File</span>
                                                        </div>
                                                        <div class="text-file-messege">
                                                            <span class="uplode-text">{{ $t('upload', 'No Choosen File') }}</span>
                                                            <!-- <span class="file-text">{{ $t('your-file', 'Your File') }}</span> -->
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div class="deposit-bg-border" v-if="previewImage">
                                                <div class="deposit-uploaded">
                                                    <div class="customPreview">
                                                        <img :src="previewImage">
                                                    </div>
                                                   
                                                    <button class="deletPreview" @click="removeImage()">
                                                        <img src="@/assets/images/cross.svg" alt="">
                                                    </button>
                                                    <div class="timer loader_timer" v-if="utrLoader">
                                                        <div class="loader_deposit">
                                                        </div>
                                                        <text id="myTimer" text-anchor="middle" x="100" y="110" style="font-size: 40px; fill:#343434;">
                                                            {{ timerValue }}
                                                        </text>
                                                    </div>
                                                    <!-- <p v-if="showAmountError" class="req-pass" >{{ amountErrorMessage  }}</p> -->
                                                </div>
                                            </div>
                                            <p v-if="init.transaction_image_url && !uploadedImage" class="req-pass file_errow_2">{{ $t('qr-code-image-is-required', 'QR Code image is required') }}</p>
                                            <div class="paymentProofFileUploadStatus px-2"v-if="paymentProofFileUploadStatus">{{ paymentProofFileUploadStatus }}</div>                                                                
                                            <div class="deposit-amount">
                                                <div class="input-area-wrap">
                                                    <label for="transactionId" class="trans_req_title">{{ $t('unique-transaction-reference', 'Unique Transaction Reference') }} 
                                                    <small style="color: red;" v-if="accountDetails?.method != 'wallet'">*</small></label>
                                                    <fieldset class="textfield ">
                                                        <input class="input-field" type="tel" :disabled="utrLoader"  v-model="manual_utr" :maxlength="accountDetails?.method != 'wallet' ? 15 : 128" :placeholder="$t('enter-utr-number', 'Enter UTR number')" @input="sanitizeInput(), has_edited_utr = 1" />
                                                    </fieldset>
                                                    <p v-if="accountDetails?.method != 'wallet' && init.utr && !manual_utr?.length" class="req-pass" > {{$t('utr-number-is-required','UTR Number is Required')}}</p>
                                                    <p v-else-if="accountDetails?.method != 'wallet' && init.utr && manual_utr?.length < 10" class="req-pass" >{{$t('utr-limit-msg','UTR number must be 10 to 15 digit')}}</p>
                                                </div>
                                                

                                                <div class="input-area-wrap input-area-box">
                                                    <label for="transactionId" class="trans_req_title">{{ $t('amount', 'Amount') }}</label>
                                                    <fieldset class="textfield">
                                                        <input class="input-field disabled" v-model="depositAmount" readonly type="number" />
                                                    </fieldset>
                                                    <!-- <p class="input-label">
                                                        ({{ $t('min-deposit', 'Min Deposit') }}: ₹{{ walletData?.minimum_deposit ? walletData?.minimum_deposit : '100' }} |
                                                         {{ $t('max-deposit', 'Max Deposit') }}: <b>₹{{ walletData?.maximum_deposit ? walletData?.maximum_deposit : '99999999' }}</b>)
                                                    </p> -->
                                                </div>

                                                <div class="btn-form w_submit">
                                                    <!-- <button type="button" @click="resetForm()" class="Reset-btn">{{ $t('reset', 'Reset') }}</button> -->
                                                    <button type="button" @click="walletDepositSubmitBtn()" class="btn-sum add-btn" :class="{ 'btn-loading': loading }">
                                                        {{ $t('submit', 'Submit') }} <span><b></b><b></b><b></b></span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="noDeposit-op" v-else>
                    "No Deposit Options Available. Contact Admin!!"
                </div>
            </div>
        </div>
         <!--qrPreview Modal -->
    <div class="modal fade" id="qrPreviewModal" tabindex="-1" aria-labelledby="qrPreviewLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="qrPreview-image">
                        <img loading="lazy" :src="currentImgLink" alt="asg_rouletted1-thumb">
                    </div>
                </div>
                <div class="searchbar-main deposit-page-close">
                    <button type="button" class="closebtn-searchh deposit-page-close-btn" data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="qrShareModal" tabindex="-1" aria-labelledby="qrPreviewLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="closeUserId($auth?.user?.userid)"></button> -->
                    <ul class="qrShare-list">
                        <li>
                            <a :href="`whatsapp://send?text=${currentImgLink}`" target="_blank">
                                <img loading="lazy" src="@/assets/images/what_share_icon.png" alt="whatsapp-share.svg">
                            </a>
                        </li>
                        <li>
                            <a :href="`https://www.facebook.com/sharer/sharer.php?u=${currentImgLink}`" target="_blank">
                                <img loading="lazy" src="@/assets/images/facebooki_share_icon.png" alt="facebook-share.svg">
                            </a>
                        </li>
                        <li>
                            <a :href="`https://t.me/share/url?url=${currentImgLink}`" target="_blank">
                                <img loading="lazy" src="@/assets/images/telegram_share_icon.png" alt="telegram-share.svg">
                            </a>
                        </li>
                        <li>
                            <a href="https://www.instagram.com/" @click="$emit('copyImgUrl')" target="_blank">
                                <img loading="lazy" src="@/assets/images/insta_share_icon.png" alt="facebook-share.svg">
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="searchbar-main deposit-page-close">
                    <button type="button" class="closebtn-searchh deposit-page-close-btn" data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    </section>
</template>

<script setup>
import {getParentPaymentsMethods, onUploadImage,submitDepositAmount, getPaymentGatewayUrl} from '../services/depositPayment';
import { useStore } from 'vuex';
import { onMounted , ref , computed , getCurrentInstance , inject } from 'vue';
// import NoDataFound from '@/shared/components/no-data/NoDataFound.vue';

const { $t, $errorToast, $successToast, $siteSettings } = getCurrentInstance().proxy;

const store = useStore();

const walletConfig = inject('walletConfig')

// refs
// const paymentMethods = ref([]);
const parentPaymentsList = ref(null);
const paymentDetailsList = ref(null);
// const awsS3Path = ref('');
// const bankS3url = ref('');
// const awsS3QrCode = ref('')
// const showFileError = ref(false);
// const showUtrError = ref(false);
// const selectedPaymentMethod = ref([])
const uploadedImage = ref(null);
const manual_utr = ref(null);
// const userJourneyVideo = ref(null);
const file = ref(undefined);
const loading = ref(false);
// const walletData = ref(null);
// const selectPaymentAccount = ref(null);
const previewImage = ref(null);
const copiedText = ref(null);
// const walletLoading = ref(false);
const currentImgLink = ref(null);
const t = ref(6);
const interval = ref(30);
const angle = ref(0);
// const angle_increment = ref(360 / 9);
const intervalCounter = ref(0);
const timerValue = ref(9);
const timer = ref(null);
const utrLoader = ref(false);
const utrerror = ref(false);
const init = ref({
    utr: false,
    transaction_image_url: false
});
const termsAgreed = ref(false);
const utrLimitError = ref(false);
const has_edited_utr = ref(0);
const currentAccount = ref(-1);
const utrMsg = ref({
    langKey: 'enter-utr',
    msg: "Kindly enter UTR Number manually for fast deposit."
});
const tesseract_utr = ref(null);
const isPaymentGateway = ref(null);
const accountDetails = ref(null);
const activeTab = ref(null);
const paymentProofFileUploadStatus = ref('');
// template ref
const sbtBtn = ref(null);
const fileRef = ref(null);

// computed
const bonusData = computed(() => store.getters?.bonusData);
const depositAmount = computed(() => store.getters?.depositAmount);
// const strokeDasharray = computed(() => `${angle.value}, 361`);
const methodIcons = computed(() => {
    let iconObj = {};
    walletConfig.value?.payment_method?.forEach(element => {
        iconObj[element.method_name] = element.icon
    });
    walletConfig.value?.bank_list?.forEach(element => {
        iconObj[element.bank_name] = element.icon
    });
    return iconObj
});
const paymentBonus = computed(() => {
    if (!bonusData.value || !Array.isArray(bonusData.value)) {
        return {};
    }

    const paymentBonusData = bonusData.value?.filter(bd => bd.bonusType === 'payment bonus');

    if (paymentBonusData.length === 0) {
        return {};
    }

    return paymentBonusData.reduce((methodBonusMap, bonusElement) => {
        try {
            const methodIds = JSON.parse(bonusElement.methodIds);
            if (Array.isArray(methodIds)) {
                methodIds.forEach(methodId => {
                    methodBonusMap[methodId] = bonusElement.percentage;
                });
            }
        } catch (error) {
            console.warn('Failed to parse methodIds for payment bonus:', bonusElement.methodIds, error);
        }
        return methodBonusMap;
    }, {})
});

const isSocialPaymentMethodSelected = computed(()=> paymentDetailsList.value?.[0]?.method == 'social');
const isShowDepositeBody = computed(()=> paymentDetailsList.value?.length && !isPaymentGateway.value && !isSocialPaymentMethodSelected.value  );

// methods
function sanitizeInput() {
    manual_utr.value = manual_utr.value?.replace(/\D+/g, '');
};
function changeAccount(account, index) {
    currentAccount.value = index
    accountDetails.value = account
    toggleInit(false)
};
function isActive(index, account) {
    if (currentAccount.value == -1) {
        changeAccount(account, index);
        return true; // Automatically make the only account active if there's just one item
    }
    return currentAccount.value === index;
};
// function gotoWhatsappDeposit() {
//     window.open('https://wa.me/' + $siteSettings?.data?.social_link?.whatsappno1 || $siteSettings?.data?.social_link?.whatsappno2, '_blank')
// };
function startTimer() {
    utrLoader.value = true;
    angle.value = 0;
    intervalCounter.value = 0;
    timerValue.value = t.value;

    if (timer.value) {
        clearInterval(timer.value);
    }

    timer.value = setInterval(() => {
        intervalCounter.value++;
        angle.value = (intervalCounter.value / (t.value * (1000 / interval.value))) * 360;

        timerValue.value = t.value - Math.floor((angle.value / 360) * t.value);

        if (timerValue.value <= 0) {
            resetTimer();
            utrLoader.value = false;
        }
    }, interval.value);
};
function clearPaymentSlip() {
    previewImage.value = null;
    manual_utr.value = '';
    file.value = undefined;
    utrLimitError.value = '';
    utrerror.value = '';
    manual_utr.value = '';
    uploadedImage.value = null;
};
function copyPaymentData(catagory, accountData) {
    if (!accountData) {
        $errorToast($t('no-data-available-to-copy', 'No Data Available To Copy.'));
        return;
    }
    var input = document.createElement('textarea');
    input.innerHTML = accountData;
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
    copiedText.value = accountData;
    $successToast(catagory + ' Copied Successfully');
    document.querySelectorAll('.copt_btn_toolTips .copty_cmn_btn i').forEach(el => {
        el.style.color = '';
    });
    setTimeout(() => {
        copiedText.value = null;
        document.querySelectorAll('.copty_cmn_btn i').forEach(el => {
            el.style.color = '#0cddff';
        });
    }, 1000);
};
// function selectPaymentMethodAccount(paymentAccount) {
//     selectPaymentAccount.value = paymentAccount.agent_bank_id;
// };
async function getParentPaymentMethods(reconnectTry = 0) {
    try {
        let response = await getParentPaymentsMethods(reconnectTry, depositAmount.value);
        if (response?.data) {
            parentPaymentsList.value = response?.data;
            let nonSocialStartIndex = response?.nonSocialStartIndex
            activeTab.value = Object.keys(parentPaymentsList.value)[nonSocialStartIndex]
            choosePaymentMethod(parentPaymentsList.value?.[activeTab.value], activeTab.value);
        }
    } catch (error) {
        $errorToast(error)
    }
};
function choosePaymentMethod(payment, index) {
    clearPaymentSlip();
    toggleInit(false);
    activeTab.value = index;
    paymentDetailsList.value = payment;
    if (payment?.[0]?.method == 'social') {
        isPaymentGateway.value = false;
        const socialNumber = payment?.[0]?.social_payment_number;
        const socialLink = payment?.[0]?.social_payment_link;
        if (socialNumber?.length && socialLink?.length) {
            const choice = Math.random() < 0.5 ? 'number' : 'link';
            if (choice === 'number') {
                if (payment?.[0]?.method_name?.toLowerCase().includes('whatsapp')) {
                    window.open(`https://wa.me/?text=${socialNumber}`, 'blank');
                } else if (payment?.[0]?.method_name?.toLowerCase().includes('telegram')) {
                    window.open(`https://t.me/${socialNumber}`, 'blank');
                }
            } else {
                window.open(socialLink, 'blank');
            }
            return;
        }
        if (socialNumber?.length) {
            if (payment?.[0]?.method_name?.toLowerCase().includes('whatsapp')) {
                window.open(`https://wa.me/?text=${socialNumber}`, 'blank');
            } else if (payment?.[0]?.method_name?.toLowerCase().includes('telegram')) {
                window.open(`https://t.me/${socialNumber}`, 'blank');
            }
            return;
        }
        if (socialLink?.length) {
            window.open(socialLink, 'blank');
            return;
        }
        $errorToast($t('no-social-payment-number', 'No social payment number available'));
        return;
    };
    if (payment?.[0]?.method == 'payment_gateway') {
        isPaymentGateway.value = true;
        paymentDetailsList.value = payment;
        return
    }
    activeTab.value = index
    // currentPaymentId.value = payment?.[0]?.method
    paymentDetailsList.value = payment
    // AccountS3Url.value = payment?.qrCodeUrl
    accountDetails.value = paymentDetailsList.value?.[0];
    currentAccount.value = 0;
    isPaymentGateway.value = false;
};
function toggleInit(bool) {
    init.value = {
        utr: bool,
        transaction_image_url: bool
    }
};
function removeImage() {
    uploadedImage.value = null;
    previewImage.value = null;
    manual_utr.value = '';
};
async function goToPaymentGateway() {
    try {
        const response = await getPaymentGatewayUrl(depositAmount.value, paymentDetailsList.value?.[0]?.master_account_id);
        console.log(response)
    } catch (error) {
        $errorToast(error)
    }
};
async function walletDepositSubmitBtn() {
    try {
        termsAgreed.value = true;
        toggleInit(true);
        if(!uploadedImage.value) return ;
        if (accountDetails.value?.method != 'wallet' && (manual_utr.value?.length < 10 || !manual_utr.value)) return;
        let response = await submitDepositAmount({
            accountDetails: accountDetails.value,
            uploadedImage: uploadedImage.value,
            depositAmount: depositAmount.value,
            manual_utr: manual_utr.value,
            removeImage: removeImage,
            has_edited_utr: has_edited_utr.value
        });

    } catch (error) {
        $errorToast(error)
    }
};
// function validateUTR() {
//     manual_utr.value = manual_utr.value?.replace(/[^0-9]/g, '')?.replace(/[+-]/g, '')
//     if (manual_utr.value == null || manual_utr.value == '')
//         utrerror.value = true;
//     else if (manual_utr.value?.length < 10 || manual_utr.value?.length > 15)
//         utrLimitError.value = true;
//     else
//         utrLimitError.value = false;
//     utrerror.value = false;
// };
function resetTimer() {
    clearInterval(timer.value);
    utrLoader.value = false;
    angle.value = 0;
    intervalCounter.value = 0;
    timerValue.value = t.value;
};
async function fileUpdateFunc(event) {
    try {
        paymentProofFileUploadStatus.value = 'Fetching payment proof file';
        const file = event.target.files?.[0];
        // Only proceed if at least one file is selected
        if (!file) {
            return $errorToast($t('no-file-selected','No File selected to upload'))
        }
        const allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
        const maxFileSize = 5 * 1024 * 1024; 
        if (!allowedTypes.includes(file.type) || file.size > maxFileSize) {
            $errorToast('Invalid file type. Only JPG, JPEG, PNG, and WEBP image formats are allowed, and file size must be under 5 MB.');
            previewImage.value = null;
            return;
        }
        paymentProofFileUploadStatus.value = 'Payment Proof File found Ready to Process';
        previewImage.value = URL.createObjectURL(file);
        let response = await onUploadImage({
            event,
            depositAmount: depositAmount.value,
            startTimer: startTimer,
            resetTimer: resetTimer,
            sbtBtn: sbtBtn.value,
            paymentProofFileUploadStatus:paymentProofFileUploadStatus
        });
        if (response) {
             if(!response?.manual_utr){
              paymentProofFileUploadStatus.value = 'UTR Number Not Found from above payment proof try with different one';
            }else{
                paymentProofFileUploadStatus.value = 'UTR Number Has been successfully extracted !!!';
            }
            manual_utr.value = response?.manual_utr
            utrMsg.value = response?.utrMsg
            uploadedImage.value = response?.uploadedImage
            previewImage.value = response?.previewImage
            tesseract_utr.value = response?.tesseract_utr
            utrLoader.value = false
            if (response.manual_utr) {
                has_edited_utr.value = 0
            }
        }
        else {
            paymentProofFileUploadStatus.value = 'Unable to Extract the UTR Number From Above Uploaded File , Please try with another file or try again after sometime';
            // this.previewImage = null
        }
    } catch (error) {
        previewImage.value = null;
        $errorToast(error);
        paymentProofFileUploadStatus.value = 'Unable to Extract the UTR Number From Above Uploaded File , Please try with another file or try again after sometime';
    } finally{
        setTimeout(() => {
            paymentProofFileUploadStatus.value = '';
        }, 2000);
    }
};
// function copyImgUrl() {
//     var input = document.createElement('textarea');
//     input.innerHTML = currentImgLink.value;
//     document.body.appendChild(input);
//     input.select();
//     document.execCommand('copy');
//     document.body.removeChild(input);
//     $successToast('Successfully copied.');
// };
function downloadQrImg(imageUrl, name) {
    const link = document.createElement('a');
    link.href = imageUrl;
    link.download = name;
    link.target = '_blank';
    link.click();
};

function onFilePickerOpen() { 
    window.addEventListener('focus', () => {        
        setTimeout(() => {
            const files = fileRef.value?.files;
            if (files?.length == 0) {
                $errorToast('File not selected. Check permission or try again!!')
            }
        }, 1000);
    }, { once: true })
}
// hooks
onMounted(getParentPaymentMethods);
</script>
<style scoped>


.loader_timer {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgb(16 16 16 / 48%);
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.loader_deposit {
  width: 60px;
  height: 60px;
  border: 6px solid transparent;
  border-top: 6px solid #fff;
  border-radius: 50%;
  animation: spin 1s linear infinite, glow 1.5s ease-in-out infinite alternate;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes glow {
  0% { box-shadow: 0 0 10px #000; }
  100% { box-shadow: 0 0 10px #000; }
}

text#myTimer {
  position: absolute;
  color: #fff;
}

.deposit-page-close-btn {
    background-color: #ffffff;
	border: 2px solid  var(--primary-color);
	color:  var(--primary-color);
	border-radius: 6px;
	font-size: 16px;
	padding: 10px 15px;
	text-transform: uppercase;
	min-width: 100px;
	font-weight: 500;
}
.searchbar-main {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-evenly;
    padding: 10px;
}

.qr-icons{
    position: relative;
}
.qr-icons  button {
    border: 0;
    background: 0;
    right: 0;
    position: initial;
    padding-top: 13px;
    background-color: #ffffff;
    border-radius: 5px;
    box-shadow: 0 5px 5px rgba(0,0,0, 0.5) !important;
    padding: 1px 9px 6px 8px;
    height: 33px;
    margin-top: 13px;
}
.qr-icons .click-qr-icons img{
    width: auto;
    max-height: 30px;
}

.qr-icons .online-payment-bank button{
    position: initial;
}
.qr-img.qr-icons {
    width: 100%;
    max-width: 100%;
    max-height: 100%;
}
.text-normal-case {
  text-transform: none;
}

</style>